// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"41c2fa8f","626":"e66d0191","696":"09f1f7c6","889":"e2ccb918","940":"a76bb0d2"}[chunkId] + ".chunk.js";
};